/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { combineReducers } from "redux";
import receiverReducer from "./ReceiverReducer";
import WaybillReducer from "./WaybillReducer";
import UserReducer from "./UserReducer";
import StatisticReducer from "./StatisticReducer"
import BundleReducer from "./BundleReducer";
import BalanceReducer from "./BalanceReducer";

export const reducers = combineReducers({
    receiver: receiverReducer,
    waybill: WaybillReducer,
    user: UserReducer,
    statistic: StatisticReducer,
    bundle: BundleReducer,
    balance: BalanceReducer,
});
  